var _rect, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "IT support icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 120,
    height: 120,
    rx: 18,
    fill: "#1e1e2e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 24a24 24 0 0 0-24 24v6a10 10 0 0 0-6 9v10a10 10 0 0 0 10 10h4V54a16 16 0 0 1 32 0v29h4a10 10 0 0 0 10-10V63a10 10 0 0 0-6-9v-6a24 24 0 0 0-24-24z",
    fill: "#4a90e2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 83v6a20 20 0 0 0 20 20h6a6 6 0 0 0 0-12h-6a8 8 0 0 1-8-8v-6z",
    fill: "#4a90e2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 60,
    r: 4,
    fill: "#1e1e2e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 60,
    r: 4,
    fill: "#1e1e2e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItSupport);
export default __webpack_public_path__ + "static/media/it-support.71eca4ee81bff37e5159bc0937a91ccd.svg";
export { ForwardRef as ReactComponent };